var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article__container"},[_c('RichTextRenderer',{attrs:{"document":_vm.content,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }